// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2 {\n  fill: #fff\n}\n.st4 {\n  fill: #f9df40\n}\n.st5 {\n  fill: #f3ed6b\n}\n", ""]);
// Exports
module.exports = exports;
